import React from "react";

import { FloatingNavButton } from "@app/analytics/components/reports/FloatingNav";
import useSearch from "@app/analytics/MeetingReport/hooks/useSearch";
import { SearchIcon } from "@app/common/assets/icons";

import MenuItem from "@rui/MenuItem";
import TooltipWrapper from "@rui/TooltipWrapper";

const SearchNavAction = ({ variant }: { variant: "button" | "menu" }) => {
  const { searchMode, setSearchMode, clearSearch } = useSearch();

  const searchOpen = Boolean(searchMode);

  const toggleSearchBox = () => {
    if (searchOpen) {
      clearSearch();
    } else {
      setSearchMode("search");
    }
  };

  if (variant === "button") {
    return (
      <TooltipWrapper placement="bottom" title="Search" show={!searchOpen}>
        <FloatingNavButton
          Icon={SearchIcon}
          onClick={toggleSearchBox}
          active={searchOpen}
        >
          Search
        </FloatingNavButton>
      </TooltipWrapper>
    );
  }

  if (searchOpen) return null;

  return (
    <MenuItem icon={<SearchIcon />} onClick={toggleSearchBox}>
      Search
    </MenuItem>
  );
};

export default SearchNavAction;
